<template>
    <div>
        <div class="filterBg base-form-div">
            <el-form size="mini" :model="searchForm" label-position="right" label-width="120px" inline>
                <el-form-item label="发送方卡号:">
                    <el-input v-model="searchForm.sendCardNumber" placeholder="请输入发送方卡号" class="filter-item" clearable
                        @keyup.enter.native="handleFilter" @clear="handleFilter" />
                </el-form-item>
                <el-form-item label="时间:">
                    <DatePicker :startTime.sync="searchForm.beginTime" :endTime.sync="searchForm.endTime" />
                </el-form-item>
            </el-form>
            <div>
                <el-button class="base-button" size="mini" type="primary" icon="el-icon-search" @click="handleFilter">查询</el-button>
                <el-button class="base-button" size="mini" type="primary" icon="el-icon-download" @click="exportFilter">导出</el-button>
            </div>
        </div>
        <div class="listTable">
            <div class="margins">
                <span>
                    <!-- <el-button size="mini" type="primary" icon="el-icon-plus" @click="addCard">新增</el-button> -->
                    <!-- <el-button type="primary" @click="manageImport">导入</el-button>
                    <el-button type="primary" @click="downfileTransfer">导出</el-button> -->
                </span>
                <span>
                    <!-- <el-button type="primary" @click="templateDown">模板下载</el-button> -->
                </span>
            </div>
            <YzTable max-height="340px" :columnApi="columns" :listApi="listArray" :searchForm="searchForm" :autoLoad="true"
                ref="YzTable" />
        </div>
    </div>
</template>
  
<script>
import { getCommonAjax } from "@/api/common"
export default {
    data() {
        return {
            columns: "json/commrecord.json?v=2",
            listArray: "/message/pageMessage",
            searchForm: {
                page: 1,
                pageSize: 10,
                sendCardNumber: undefined,
                beginTime: undefined,
                endTime: undefined
            },
        };
    },
    created() {
    },
    mounted() {
    },
    beforeDestroy() {
    },
    methods: {
        exportFilter() {
            getCommonAjax("/message/exportMessage", this.searchForm,"arraybuffer").then(res => {
                this.downloadJsonFile(res, '历史通讯记录_' + new Date().getTime() + ".xlsx")
            }).catch(err => {
                console.error(err);
            });
        },
        downloadJsonFile(data, fileName) {
            var blob = new Blob([data], { type: 'application/octet-stream' });
            var url = URL.createObjectURL(blob);
            var link = document.createElement('a');
            link.download = fileName;
            link.href = url;
            link.click();
            URL.revokeObjectURL(url);
        },
        handleFilter() {
            this.searchForm.page = 1;
            this.$refs["YzTable"].getList(this.searchForm, true);
        },
        addCard() {
            this.$dialog.open({
                title: "添加设备",
                shade: true,
                area: {
                    height: "350px",
                    width: "400px",
                },
                location: {
                    top: null,
                    left: null,
                    bottom: "300px",
                    right: "20px",
                },
                content: {
                    type: "vue",
                    subCom: Add
                },
            });
        },
        handleEdit(index, row) {
            console.log(index, row);
        },
        handleDelete(index, row) {
            this.$confirm("此操作将永久删除, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    deletedUser({ id: row.id })
                        .then(() => {
                            this.getList();
                            this.$message({
                                type: "success",
                                message: "删除成功!",
                            });
                        })
                        .catch((e) => {
                            //this.$message.error(e);
                        });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消删除",
                    });
                });
        },
    },
};
</script>
<style lang="scss" scoped>
.filterBg {
    display: flex;
    justify-content: space-between;
}
</style>